export default __webpack_public_path__ + "static/media/footerImg.904524b1.png";